import React, { useEffect, useState } from 'react';
import { Box, Paper, Stack, Table, TableCell, TableRow, TableHead, TableBody, Chip } from '@mui/material';
import { Icon } from '@iconify/react';
import GlobalWrapper from '../../../../../components/Wrapper/GlobalWrapper';
import { LogButton, ViewButton } from '../../../../../components/mui/Buttons/Buttons';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch, useSelector } from 'react-redux';
import Loader3D from '../../../../../components/Loader/Loader3D';
import { getOGARemarks } from '../../../../../redux/features/croSlice';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';

const OGARemarks = ({ data, CROAssignID, name, course, classType, contactNumber }) => {
  const [open, setOpen] = useState(false);

  const { ogaremarkscrd, loading } = useSelector((state) => state.cro);

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      dispatch(getOGARemarks(CROAssignID));
    }
  }, [open]);

  const headers = [
    'Student Details(In Brief)',
    'Subjects & Session Count per Subject',
    'Fee per Session',
    'Session per Week',
    'Time Prefered',
    'Trainer Prefered',
    'Total Fees',
    'Fee Status',
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 13,
      border: '1px solid #ccc',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      border: '1px solid #ccc',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  return (
    <GlobalDialog
      title="OGA Remarks"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={'lg'}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <GlobalWrapper>
              <Paper
                sx={{
                  margin: 1,
                  borderRadius: 4,
                }}
              >
                {name && (
                  <Stack direction={'row'} spacing={2}>
                    <Chip label={`Name : ${name ?? ''}`} color="primary" variant="outlined" />
                    <Chip label={`Contact No : ${contactNumber ?? ''}`} color="primary" variant="outlined" />
                    <Chip label={`Class : ${classType ?? ''}`} color="primary" variant="outlined" />
                    <Chip label={`Course : ${course ?? ''}`} color="primary" variant="outlined" />
                  </Stack>
                )}
                <Table
                  aria-label="simple table"
                  sx={{
                    border: '1px solid #ccc',
                    borderCollapse: 'collapse',
                    marginTop: 2,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {headers.map((header, index) => (
                        <TableCell key={index} sx={{ borderRight: '1px solid #ccc' }} align="center">
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_student_details}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_subjects_sessions}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_fee_per_session}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_class_per_week}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_time_prefered}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_trainer_prefered}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_total_fees}
                      </StyledTableCell>
                      <StyledTableCell sx={{ borderRight: '1px solid #ccc' }} align="center">
                        {ogaremarkscrd.sro_remarks_fee_status}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </Paper>
            </GlobalWrapper>
          )}
        </>
      }
    />
  );
};

export default OGARemarks;
